<h1 class="label">{{ label() }}</h1>
<ng-content/>
